<template>
  <div class="home-container">
    <div  class='home'>
    <Form v-if='!empty' :company='ngo' />
    <div v-else> something went wrong....... yep, thats all we know.</div>
    </div>
 
  </div>
</template>

<script>
// @ is an alias to /src
import Form from '@/components/Form.vue'


export default {
  mounted() {
            this.$axios.get(
          `https://us-central1-donorconnection-df169.cloudfunctions.net/partnerapi/companyProfile/${this.$route.params.refurbisher}/${this.$route.params.company}`).then((response) => {
            response.data === "" ? this.empty = true :  this.ngo = response.data;
           
            
        })
  },
  data() {
    return{
      empty : false,
      ngo : null,
      ngoName : ''
    }
  },
  components: {
    Form
  }
}
</script>

<style scoped>
.home-container {
   background-image: url('https://storage.googleapis.com/donorconnection-df169.appspot.com/ezgif-6-a7648c1668d6.webp');
    width: 100%;  
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.home {
 width: 100%;  
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  
  align-items: center;
  padding: 15px;
}
</style>